import React, { useState } from "react";
import Register from "./Register";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import axios from "axios";
import BackGroundColor from "../CommanComponents/BackGroundColor";
import api from "../utils/api";

function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const submit = async (values, { resetForm }) => {
    setLoading(true);
    try {
      const res = await api.post("login", values);

      if (res.status === 200) {
        const { token, refreshToken, user } = res.data;
        localStorage.setItem("token", token);
        if (refreshToken) {
          localStorage.setItem("refreshToken", refreshToken);
        }
        localStorage.setItem("postUser", JSON.stringify(user));
        navigate("/protected");
        resetForm();
      }
    } catch (error) {
      console.error("Giriş hatası:", error);
      alert("Giriş yapılamadı!");
    } finally {
      setLoading(false);
    }
  };
  const { values, errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues: {
      email: "",
      password: "",
      verify: false,
    },
    onSubmit: submit,
  });

  return (
    <div
      className="min-h-screen flex flex-col justify-center items-center 
    bg-yellow-100 relative overflow-hidden"
      style={{
        fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
      }}
    >
      {/* Fun Background Elements */}
      <BackGroundColor />
      {/* Content */}
      <div className="z-10 bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <h1 className="text-3xl text-blue-600 font-bold mb-2">Classroom</h1>
          <div className="text-lg text-purple-500 font-semibold flex flex-col">
            Let's Learn Together!
            <hr className="border-1.5 border-yellow-500" />
            <span className="text-sm text-purple-500 font-normal text-center">
              Haydi birlikte öğrenelim!
            </span>
          </div>
        </div>

        <div className="w-full">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col justify-center items-center p-4 gap-6">
              <div className="flex flex-col gap-2 w-full">
                <label
                  htmlFor="email"
                  className="block text-lg font-bold text-orange-500"
                >
                  Email
                </label>
                <input
                  type="text"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  className="w-full h-12 text-xl rounded-full px-4 outline-none border-2 border-purple-300 focus:border-purple-500"
                  placeholder="eposta-adresiniz@ornek.com"
                />
              </div>

              <div className="flex flex-col gap-2 w-full">
                <label
                  htmlFor="password"
                  className="block text-lg font-bold text-orange-500"
                >
                  Şifre
                </label>
                <input
                  type="password"
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  className="w-full h-12 text-xl rounded-full px-4 outline-none border-2 border-purple-300 focus:border-purple-500"
                  placeholder="••••••••"
                />
              </div>
              <div className="flex justify-end ml-50">
                <button
                  type="button"
                  onClick={() => navigate("/forgat_password")} // Fixed the typo here
                  className="text-blue-500 hover:text-blue-700"
                >
                  {/* <span> Forget Password</span>
                  <hr className="border-1 border-yellow-400" /> */}
                  <span className="text-sm text-blue-500 font-normal text-center">
                    Şifremi Unuttum
                  </span>
                </button>
              </div>
              <div className="w-full mt-4">
                <button
                  className="bg-green-500 hover:bg-green-600 text-white text-xl 
                  font-bold rounded-full w-full h-14 transition-colors duration-300 flex flex-col
                   items-center justify-center"
                  type="submit"
                >
                  Öğrenmeye başla
                  {/* <hr className="border-0.5 border-yellow-400 w-36" />
                  <span className="text-sm font-normal">Öğrenmeye başla</span> */}
                </button>
              </div>
              {/* <div className="mt-4 text-center flex gap-2">
                <div className="flex flex-col mt-5">
                  <span>If you don't have an account?</span>
                  <hr className="border-0.5 border-yellow-400 w-48" />
                  <span className="text-sm text-blue-500 font-normal text-center">
                    Eğer bir hesabınız yoksa?
                  </span>
                </div>

                <button
                  type="button"
                  onClick={() => navigate("/register")} // Fixed the typo here
                  className="text-blue-500 hover:text-blue-700 "
                >
                  <span> register (kayıt ol)</span>
                </button>
              </div> */}
              <div className="mt-4 text-center flex items-center justify-center gap-2 w-full">
                <div className="flex flex-col">
                  {/* <hr className="border-0.5 border-yellow-400 w-48" /> */}
                  <span className="text-sm text-blue-500 font-normal text-center">
                    Eğer bir hesabınız yoksa?
                  </span>
                </div>

                <button
                  type="button"
                  onClick={() => navigate("/register")}
                  className="text-blue-500 hover:text-blue-700"
                >
                  <span className="text-sm font-normal">kayıt ol</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
